/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Edge,
  EdgeType,
} from '@/models';

import edges from './data/edges';

export async function fetchEdges<DataType, SrcType = any, DestType = any>(
  type: EdgeType,
  srcId: string,
  destId: string): Promise<Array<Edge<DataType, SrcType, DestType>>> {
  // TODO: Server-side request
  const result: Array<Edge<DataType, SrcType, DestType>> = [];
  for (const edge of edges) {
    if (edge.type === type && edge.src.id === srcId && edge.dest.id === destId) {
      result.push(edge);
    }
  }
  return result;
}

export async function fetchEdgesTo<DataType, SrcType = any, DestType = any>(
  type: EdgeType,
  destId: string): Promise<Array<Edge<DataType, SrcType, DestType>>> {
  // TODO: Server-side request
  const result: Array<Edge<DataType, SrcType, DestType>> = [];
  for (const edge of edges) {
    if (edge.type === type && edge.dest.id === destId) {
      result.push(edge);
    }
  }
  return result;
}
